import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, Phone, MapPin, Clock } from "lucide-react";
import { LOGO_BLACK } from "@/components/Logo";
import { api } from "@/lib/api";
import { cget, cset } from "@/lib/cached";

export default function Footer() {
  const [copy, setCopy] = useState(() => cget("imu_copy") || {});
  useEffect(() => {
    api.get("/settings/copy").then((r) => { setCopy(r.data); cset("imu_copy", r.data); }).catch(() => {});
  }, []);
  const t = (k, f = "") => copy[k] ?? f;
  return (
    <footer className="mt-32 bg-ink-900 text-cream-100" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <img src={LOGO_BLACK} alt="IMMUSKI" className="h-24 sm:h-32 w-auto" />
            <div className="eyebrow mt-4 text-gold-400">Science · Nature · You</div>
            <p className="mt-8 text-sm text-cream-100/70 max-w-md leading-relaxed">
              {t("footer_about", "Clinically-inspired skincare and haircare, formulated with dermatologists and made in India. Cruelty-free. Sulphate & Paraben-free.")}
            </p>
          </div>
          <div className="md:col-span-2">
            <div className="eyebrow text-gold-400">Shop</div>
            <ul className="mt-6 space-y-3 text-sm text-cream-100/80">
              <li><Link to="/shop" className="hover:text-gold-400">All products</Link></li>
              <li><Link to="/shop?cat=face" className="hover:text-gold-400">Face</Link></li>
              <li><Link to="/shop?cat=hair" className="hover:text-gold-400">Hair</Link></li>
              <li><Link to="/shop?cat=sun" className="hover:text-gold-400">Sun</Link></li>
              <li><Link to="/shop?cat=cleanser" className="hover:text-gold-400">Cleanse</Link></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <div className="eyebrow text-gold-400">Company</div>
            <ul className="mt-6 space-y-3 text-sm text-cream-100/80">
              <li><Link to="/about" className="hover:text-gold-400">About us</Link></li>
              <li><Link to="/dermatologists" className="hover:text-gold-400">Talk to a Derm</Link></li>
              <li><Link to="/contact" className="hover:text-gold-400">Contact us</Link></li>
              <li><Link to="/track" className="hover:text-gold-400">Track orders</Link></li>
              <li><Link to="/account" className="hover:text-gold-400">My account</Link></li>
              <li><Link to="/returns" className="hover:text-gold-400" data-testid="footer-returns">Return & Refund</Link></li>
            </ul>
          </div>
          <div className="md:col-span-4">
            <div className="eyebrow text-gold-400">Contact</div>
            <ul className="mt-6 space-y-3 text-sm text-cream-100/80" data-testid="footer-contact">
              <li className="flex items-start gap-2"><Mail size={14} className="mt-1 shrink-0" /> <a href={`mailto:${t("contact_email", "hello@immuski.com")}`} className="hover:text-gold-400">{t("contact_email", "hello@immuski.com")}</a></li>
              <li className="flex items-start gap-2"><Phone size={14} className="mt-1 shrink-0" /> <a href={`tel:${(t("contact_phone", "") || "").replace(/\s+/g, "")}`} className="hover:text-gold-400">{t("contact_phone", "+91 99999 99999")}</a></li>
              <li className="flex items-start gap-2"><Clock size={14} className="mt-1 shrink-0" /> <span>{t("contact_hours", "Mon–Sat, 10 AM – 7 PM IST")}</span></li>
              <li className="flex items-start gap-2"><MapPin size={14} className="mt-1 shrink-0" /> <span>{t("contact_address", "")}</span></li>
              <li className="flex items-start gap-2"><Instagram size={14} className="mt-1 shrink-0" /> <span>{t("footer_contact_instagram", "@immuski")}</span></li>
            </ul>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-cream-100/10 flex flex-col md:flex-row justify-between text-xs text-cream-100/50 gap-4">
          <div>© {new Date().getFullYear()} IMMUSKI — Marketed by Swasth Derma Labs</div>
          <div className="flex flex-wrap gap-4 sm:gap-6">
            <span>ISO Certified</span>
            <span>GMP</span>
            <span>Cruelty Free</span>
            <span>Made in India</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
